export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.25-1328.04",
  commitId: "edc09f8d09405fbd97576c99ec944161845e314d",
  commitTime: "2026-06-25T13:28:04.000Z",
});
